module.exports = __webpack_public_path__ + "static/media/inr-rs-1.a9736490.png";